/**
 * Strip HTML tags and decode common HTML entities from a string,
 * then collapse whitespace and (optionally) truncate.
 *
 * Used for rendering blog post excerpts in list views where the source
 * `content` field is raw HTML but the card only has room for plain text.
 */
export function stripHtml(html, maxLength) {
  if (!html || typeof html !== "string") return "";

  // Remove tags
  let text = html.replace(/<[^>]*>/g, " ");

  // Decode the common HTML entities
  text = text
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&rsquo;/g, "\u2019")
    .replace(/&lsquo;/g, "\u2018")
    .replace(/&rdquo;/g, "\u201D")
    .replace(/&ldquo;/g, "\u201C")
    .replace(/&hellip;/g, "\u2026")
    .replace(/&mdash;/g, "\u2014")
    .replace(/&ndash;/g, "\u2013");

  // Collapse whitespace
  text = text.replace(/\s+/g, " ").trim();

  if (typeof maxLength === "number" && text.length > maxLength) {
    text = text.slice(0, maxLength).trimEnd() + "\u2026";
  }

  return text;
}

/**
 * Pick the best plain-text preview for a blog/recipe/etc.
 * Prefer an explicit excerpt; fall back to stripping HTML from content.
 */
export function buildPreview(item, maxLength = 160) {
  const excerpt = (item?.excerpt || "").trim();
  if (excerpt) return stripHtml(excerpt, maxLength);
  return stripHtml(item?.content, maxLength);
}
